import React, { SVGProps } from 'react'

const SvgFlagNew = (props: SVGProps<SVGSVGElement>): React.ReactElement => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-hidden="true"
    fill="none"
    {...props}
  >
    <path
      d="M5.33203 14.4998C5.33203 14.4998 6.16536 13.6665 8.66536 13.6665C11.1654 13.6665 12.832 15.3332 15.332 15.3332C17.832 15.3332 18.6654 14.4998 18.6654 14.4998V4.49984C18.6654 4.49984 17.832 5.33317 15.332 5.33317C12.832 5.33317 11.1654 3.6665 8.66536 3.6665C6.16536 3.6665 5.33203 4.49984 5.33203 4.49984L5.33203 20.3332"
      stroke={props.stroke || '#D5404A'}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      fill={props.fill || 'none'}
    />
  </svg>
)
export default SvgFlagNew
